import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Badge, { BadgeProps } from '@mui/material/Badge';

const useStyles = makeStyles()(theme => ({
  // common styles
  badge: {
    minWidth: '22px',
    height: '22px',
  },
  // Kinds
  inline: {
    alignSelf: 'center',
    position: 'initial',
    transform: 'initial',
    lineHeight: 1,
  },
  noBackground: {
    color: '#DC3C37',
    display: 'contents',
  },
  iconButton: {
    top: '7px',
    right: '5px',
  },
  mobile: {
    top: '6px',
  },
  // Extra colors
  white: {
    background: 'white',
    color: theme.palette.grey[900],
  },
  grey: {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.text.primary,
  },
  orange: {
    backgroundColor: theme.palette.orange.main,
    color: theme.palette.orange.contrastText,
  },
  default: {
    background: theme.palette.orange.main,
    color: theme.palette.white.main,
  },
}));

export enum Kind {
  default = 'default',
  mobile = 'mobile',
  inline = 'inline',
  iconButton = 'iconButton',
  noBackground = 'noBackground',
  mui = 'mui',
}

type BadgeColors = BadgeProps['color'];
type CustomColor = 'white' | 'grey' | 'orange';
const customColors: CustomColor[] = ['white', 'grey', 'orange'];

export type BadgeCustomColors = BadgeColors | CustomColor;

interface OwnProps {
  kind?: Kind;
  color?: BadgeCustomColors;
  showZero?: boolean;
  badgeClassName?: string;
}

export type Props = OwnProps & Omit<BadgeProps, 'color'>;

const BadgeNext: React.FC<Props> = ({
  children,
  badgeContent,
  color = 'primary',
  kind = Kind.default,
  badgeClassName,
  showZero,
  ...rest
}) => {
  const { classes, cx } = useStyles();

  return (
    <Badge
      {...rest}
      color={
        customColors.includes(color as CustomColor)
          ? undefined
          : (color as BadgeColors)
      }
      badgeContent={badgeContent}
      classes={{
        badge: cx(
          badgeClassName,
          classes[color],
          kind !== Kind.mui && classes.badge,
          kind !== Kind.mui && classes[kind],
        ),
      }}
      showZero={showZero}
    >
      {children}
    </Badge>
  );
};

export { BadgeNext };
